"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const State_1 = __importDefault(require("./modules/State"));
class EBecropService {
    constructor(url = '') {
        this.data = [];
        this.url = url;
        this.isLoading = false;
        this.isLoadingOrder = false;
    }
    async call() {
        await this.fetch();
    }
    async fetch() {
        this.isLoading = true;
        try {
            if (this.url === 'hight') {
                const request = await fetch('/data/results/ebecrop?resolution=hi-res');
                const response = await request.json();
                this.data = response.ebecrop.map((state) => new State_1.default(state));
            }
            else if (this.url === 'low') {
                const request = await fetch('/data/results/ebecrop');
                const response = await request.json();
                this.data = response.ebecrop.map((state) => new State_1.default(state));
            }
        }
        catch (error) {
            console.log(error);
        }
        this.isLoading = false;
    }
    async orderBecrop(state, fieldName, fieldId, metric, crop, coordinates, geodata, hectares, isCreateDrawingZone, email, recomendationsAccess) {
        this.isLoadingOrder = true;
        const config = {
            baseURL: '/data/results/ebecrop/request/message',
            timeout: 30000,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
            },
        };
        const data = {
            region: state.length > 0 ? state : 'No specific area',
            fieldName: fieldName.length > 0 ? fieldName : 'No specific field',
            fieldId: fieldId,
            metric: metric.length > 0 ? metric : 'No specific metric',
            crop: crop.length > 0 ? crop : 'No specific crop',
            coordinates: coordinates,
            geodata: geodata,
            extension: hectares,
            extension_unit: 'hectares',
            customZone: isCreateDrawingZone,
            email: email,
            requested_recommendations_by_client: recomendationsAccess
        };
        axios_1.default.create(config);
        try {
            await axios_1.default.post(config.baseURL, data);
        }
        catch (e) {
            console.log(e);
        }
        setTimeout(() => {
            this.isLoadingOrder = false;
        }, 1500);
    }
}
exports.default = EBecropService;
